import React, { Component, PropTypes }	from "react";
import ReactDOM							from "react-dom";
import ReactCSSTransitionGroup			from "react-addons-css-transition-group";
import classNames						from "classnames";

const ESC_KEY_CODE			= 27;
const TRANSITION_TIMEOUT	= 300;

class Modal extends Component {

	constructor(props) {
		super(props);

		this._handleClick = this._handleClick.bind(this);
		this._handleKeyup = this._handleKeyup.bind(this);
	}

	componentDidMount () {
		const { closeOnClickOutside, closeOnEsc } = this.props;
		if(closeOnClickOutside) {
			window.addEventListener("click", this._handleClick);
		}
		if(closeOnEsc) {
			window.addEventListener("keyup", this._handleKeyup);
		}
	}

	componentWillUnmount() {
		const { closeOnClickOutside, closeOnEsc } = this.props;
		//if(closeOnClickOutside) {
			window.removeEventListener("click", this._handleClick);
		//}
		//if(closeOnEsc) {
			window.removeEventListener("keyup", this._handleKeyup);
		//}
	}

	render() {
		const classes = classNames({
			"modal"			: true,
			"modal--light"	: this.props.mask === "light"
		});
		return (
			<ReactCSSTransitionGroup
				transitionName="a-fade"
				transitionEnterTimeout={TRANSITION_TIMEOUT}
				transitionLeaveTimeout={TRANSITION_TIMEOUT}>

				{this.props.isOpen && (
					<div className={classes}>
						<div className="modal__table">
							<div className="modal__cell" ref="cell">
								{this.props.children}
							</div>
						</div>
					</div>
				)}
			</ReactCSSTransitionGroup>
		);
	}

	_handleClick(event) {
		const cellNode = ReactDOM.findDOMNode(this.refs.cell);
		const targetNode = ReactDOM.findDOMNode(event.target);
		if(targetNode === cellNode) {
			this.props.onClose();
		}
	}

	_handleKeyup(event) {
		const isEscKey = event.keyCode === ESC_KEY_CODE;
		if(isEscKey) {
			this.props.onClose();
		}
	}
}

Modal.propTypes = {
	isOpen				: PropTypes.bool.isRequired,
	closeOnClickOutside	: PropTypes.bool,
	closeOnEsc			: PropTypes.bool,
	mask				: PropTypes.string,
	onClose				: PropTypes.func.isRequired
}

Modal.defaultProps = {
	isOpen				: false,
	closeOnClickOutside	: false,
	closeOnEsc			: false,
	mask				: "dark",
	onClose				: () => {}
};

export default Modal;



// WEBPACK FOOTER //
// ./src/js/common/components/Modal.js